import React from 'react';
import TrainingBloc from './TrainingBloc';
import RestBloc from './RestBloc';
import { IBloc, IBlocGroup } from '../classes';
import './ExerciseContainer.css';
import { WithTranslation, withTranslation } from 'react-i18next';
interface IExercciseContainerProps extends WithTranslation{
    blocGroupContainer: [IBlocGroup];
    hangboard: any;
    intensityType: string;
}

const ExerciseContainerEdit =(props: IExercciseContainerProps) =>{
    const displayBlocGroup = () => {
        return props.blocGroupContainer.map((blocGroup: IBlocGroup) =>
            <div className='bloc-container'>
                <div className='reps'>
                    {displayBlocs(blocGroup.blocs)}
                </div>
                {blocGroup.multiplier ? 
                    <div className='multiplier'>
                        <div className='circle'>
                            <h4>X {blocGroup.multiplier}</h4>
                        </div>
                        
                    </div>
                    :
                    null
                }
            </div>
        );
    }
    const displayBlocs=(blocs: [IBloc])=>{
        return blocs.map((bloc: IBloc)=>{
            //const line =bloc.id != blocs[blocs.length-1].id?<div className='line'></div>:null;
            if ((bloc as any).intensity)
                return (
                <>
                    <TrainingBloc bloc={bloc as any} hangboard={props.hangboard} intensityType={props.intensityType} />
                </>)
            else
                return (
                <>
                    <RestBloc bloc={bloc}/>
                </>)
        });
    }
    return (
        <div>
            <h3>{props.t('details.overview')}</h3>
            <div>
                {displayBlocGroup()}
            </div>            
        </div>
    )
}





export default withTranslation('workout') (ExerciseContainerEdit);